import { useState } from 'react'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { BusquedasTab } from '../components/BusquedasTab'
import { RegistrosTab } from '../components/RegistrosTab'
import { VideosTab } from '../components/VideosTab'

const DIAS_OPCIONES = [30, 60, 90] as const
type Dias = (typeof DIAS_OPCIONES)[number]

export function ReporteSueroterapiaPage() {
  const [dias, setDias] = useState<Dias>(90)

  return (
    <div className="p-4 space-y-5">
      {/* Header */}
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <h1 className="text-xl font-bold">Reporte de Sueroterapia</h1>
        <div className="flex items-center gap-2">
          <span className="text-xs text-muted-foreground">Período:</span>
          {DIAS_OPCIONES.map((d) => (
            <button
              key={d}
              onClick={() => setDias(d)}
              className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                dias === d
                  ? 'bg-blue-800 text-white'
                  : 'bg-muted text-muted-foreground hover:bg-muted/70'
              }`}
            >
              {d} días
            </button>
          ))}
        </div>
      </div>

      {/* Secciones */}
      <Tabs defaultValue="busquedas" className="space-y-4">
        <TabsList>
          <TabsTrigger value="busquedas">Búsquedas</TabsTrigger>
          <TabsTrigger value="videos">Videos</TabsTrigger>
          <TabsTrigger value="registros">Registros</TabsTrigger>
        </TabsList>
        <TabsContent value="busquedas">
          <BusquedasTab dias={dias} />
        </TabsContent>
        <TabsContent value="videos">
          <VideosTab dias={dias} />
        </TabsContent>
        <TabsContent value="registros">
          <RegistrosTab dias={dias} />
        </TabsContent>
      </Tabs>
    </div>
  )
}
